import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export const useRemSize = () => {
  const $ = _c(4);
  const [remSize, setRemSize] = useState(16);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (typeof window !== "undefined") {
        const initialRemSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        setRemSize(initialRemSize);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (typeof window === "undefined") {
        return;
      }
      const queries = [window.matchMedia("(max-width: 1520px) and (min-width: 1181px)"), window.matchMedia("(max-width: 1180px)")];
      const updateRemSize = () => {
        const newRemSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
        setRemSize(newRemSize);
      };
      queries.forEach(query => {
        query.addEventListener("change", updateRemSize);
      });
      return () => {
        queries.forEach(query_0 => {
          query_0.removeEventListener("change", updateRemSize);
        });
      };
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  return remSize;
};